import { versionMajorMinor } from 'typescript';

// GENERATED: This file is generated by build-tools/code-gen.ts -- Do not edit by hand!

/** The short version number for this JSII compiler (e.g: `X.Y.Z`) */
export const SHORT_VERSION = '6.0.9';

/** The qualified version number for this JSII compiler (e.g: `X.Y.Z (build #######)`) */
export const VERSION = '6.0.9 (build 547955e)';

/** The release line identifier for this JSII compiler (e.g: `X.Y`) */
export const RELEASE_LINE = versionMajorMinor;
